<template>
    <v-container fluid not-found primary>
        <div>
             <div class="not-found-text">404</div>
             <p class="redirect-block">Перейти на
                 <router-link
                         to="/requests"
                 >
                     главную страницу
                 </router-link>
             </p>
        </div>
    </v-container>
</template>

<script>
    export default {
        name: "NotFound"
    }
</script>

<style scoped>
    .not-found{
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }
    .not-found-text{
        font-size: 220px;
        font-weight: 300;
        color: #fff;
    }
    .redirect-block{
        color: rgba(255, 255, 255, 0.6);
        text-align: center;
    }
    .redirect-block a{
        text-decoration: underline;
        color: #fff;
    }
</style>